import clsx from "clsx";
import { useNavigate } from "react-router";
import { Divider } from "../tailwind/divider";
import { Text } from "../tailwind/text";
import { useFindMany } from "@gadgetinc/react";
import { api } from "../../api";
import { Table, TableBody, TableCell, TableRow } from "../tailwind/table";
import { Badge } from "../tailwind/badge";
import { Link } from "../tailwind/link";
import LoadingSpinner from "../LoadingSpinner";
import { PencilIcon } from "@heroicons/react/24/outline";
import posthog from "posthog-js";

export function AccessOngoingDrafts({ customerId, className }) {
  const navigate = useNavigate();
  const [{ data: draftScenarios, fetching }] = useFindMany(api.scenario, {
    filter: {
      customerId: { equals: customerId },
      isArchived: { notEquals: true },
      OR: [
        {
          AND: [
            { type: { equals: "campaign" } },
            {
              campaign: {
                isArchived: { notEquals: true },
              },
            },
            {
              NOT: {
                campaign: {
                  sendings: {
                    some: {
                      AND: [
                        { isTest: { notEquals: true } },
                        {
                          OR: [
                            { status: { equals: "completed" } },
                            { status: { equals: "registered" } },
                          ],
                        },
                      ],
                    },
                  },
                },
              },
            },
          ],
        },
        {
          AND: [
            { type: { equals: "chatbot" } },
            { status: { equals: "inactive" } },
          ],
        },
        {
          AND: [
            { type: { equals: "automation" } },
            {
              campaign: {
                isArchived: { notEquals: true },
                isAutomationActive: { equals: false },
              },
            },
          ],
        },
      ],
    },
    sort: {
      updatedAt: "Descending",
    },
    select: {
      id: true,
      name: true,
      type: true,
      campaign: { id: true },
    },
    first: 3,
  });

  return (
    <div
      className={clsx(
        className,
        "border rounded-xl pt-3 px-3 shadow min-h-44 bg-white",
      )}
    >
      <Text className="text-lg font-bold">Your ongoing work</Text>
      <Divider />
      {fetching && <LoadingSpinner />}
      {!fetching && draftScenarios && draftScenarios.length === 0 && (
        <div className="h-full flex items-center pb-6">
          <Text className="text-lg pb-2">Let's start something new 🚀</Text>
        </div>
      )}
      {!fetching && draftScenarios && draftScenarios.length > 0 && (
        <Table dense>
          <TableBody>
            {draftScenarios.map((scenario, index) => {
              return (
                <TableRow key={scenario.id}>
                  <TableCell>
                    <Badge color="sky">Draft</Badge>
                  </TableCell>
                  <TableCell>
                    {scenario.name?.length > 23
                      ? scenario.name?.slice(0, 20) + "..."
                      : scenario.name}
                  </TableCell>
                  <TableCell>
                    <div className="flex hover:cursor-pointer hover:underline items-center">
                      <PencilIcon className="h-4 w-4 mr-2" />
                      <Link
                        onClick={() => {
                          posthog.capture("user_clicked_ongoing_shortcut", {
                            position: index + 1,
                            scenario_type: scenario.type,
                          });
                          navigate(
                            `/${scenario.type}s/edit/${scenario.type === "chatbot" ? scenario.id : scenario.campaign.id}`,
                          );
                        }}
                      >
                        Edit {scenario.type}
                      </Link>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
